
import {Component, Vue, Watch} from 'vue-property-decorator'
import MainMenu from '@/views/main/main-menu.vue'
import DashboardModuleInfo from '@/model/user/DashboardModuleInfo'
import NameUtil from '@/utils/NameUtil'
import StoreDefineUser from '@/define/store/user/user'

@Component({
  components: {MainMenu}
})
export default class MainIndex extends Vue {
  private static readonly MSG_TAG_GET_TOKEN: string = 'GET_TOKEN'

  mounted() {
  }

  get selectedDashboardModule(): DashboardModuleInfo {
    return this.$store.getters[NameUtil.CSCK(StoreDefineUser.GET_SELECTED_DASHBOARD_MODEL)]
  }

  @Watch('selectedDashboardModule')
  onModuleChange(selectedDashboardModule: DashboardModuleInfo) {
    this.$router.push('module-' + selectedDashboardModule.entranceUrl)
  }
}
